import http from '@/shared/api/http'

export function getCompanyLogo() {
  return http.get('/users/me/company-logo', { responseType: 'blob' })
}

export function validateCompanyLogo(file) {
  if (!file || !/\.(png|jpe?g)$/i.test(file.name) ||
      !['image/png', 'image/jpeg'].includes(file.type)) {
    return 'Выберите изображение PNG, JPG или JPEG.'
  }
  if (file.size > 2 * 1024 * 1024) return 'Размер логотипа не должен превышать 2 МБ.'
  if (!file.size) return 'Выбранный файл пуст.'
  return ''
}

export function uploadCompanyLogo(file) {
  const error = validateCompanyLogo(file)
  if (error) return Promise.reject(new Error(error))
  const data = new FormData()
  data.append('file', file)
  return http.put('/users/me/company-logo', data)
}

export function deleteCompanyLogo() {
  return http.delete('/users/me/company-logo')
}
